
import { useQuery } from '@tanstack/react-query';
import { fetchSubstackPosts, SubstackPost } from '@/services/substackService';

export const useSubstackFeed = (limit = 10) => {
  return useQuery({
    queryKey: ['substack-posts', limit],
    queryFn: () => fetchSubstackPosts(limit),
    refetchInterval: 30 * 60 * 1000, // Refetch every 30 minutes
    retry: 2,
    staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
  });
};
